import React, { useEffect, useState } from "react";
import { AlertaNotaPromissoria } from "../../features/nota-promissoria";
import { SuporteTituloAlerta } from "../../features/suporte";
import { temTela } from "../../utils/config";
import { cn } from "../../lib/utils";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false); // Start closed on mobile

  // Set sidebar open by default on desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setSidebarOpen(true);
      } else {
        setSidebarOpen(false);
      }
    };

    // Set initial state
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="h-screen flex overflow-hidden bg-background">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex flex-col flex-1 min-w-0">
        <Header onMenuClick={handleSidebarToggle} sidebarOpen={sidebarOpen} />

        <main
          className={cn(
            "flex-1 overflow-auto pt-16 transition-all duration-200",
            sidebarOpen ? "md:ml-72" : "ml-0"
          )}
        >
          <div className="w-full px-6 py-6 lg:px-10">{children}</div>
        </main>
      </div>

      {/* Aviso global: NP vencida sem baixa ou vencendo em 15 dias. Aparece em
          todas as telas e reabre a cada troca de tela. */}
      <AlertaNotaPromissoria />

      {/* "(N)" no título da aba: atendimentos com mensagem nova do entregador. */}
      {temTela("gestorSuporte") && <SuporteTituloAlerta />}
    </div>
  );
}
